import { render, staticRenderFns } from "./ViewRules.vue?vue&type=template&id=ff5fa1b0&scoped=true&"
import script from "./ViewRules.vue?vue&type=script&lang=js&"
export * from "./ViewRules.vue?vue&type=script&lang=js&"
import style0 from "./ViewRules.vue?vue&type=style&index=0&id=ff5fa1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5fa1b0",
  null
  
)

export default component.exports